import React, { useEffect, useState, useRef } from 'react';
import { Button, Card, Col, DatePicker, Form, Tag, InputNumber, message, Table, Row, Select, Space, Modal } from 'antd';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions } from '@/scripts/utils';
import { FORM_RULE_REQUIRED } from '@/scripts/config';
import dayjs from 'dayjs';
import ajax from '@/scripts/ajax';
import axios from 'axios';
import _ from 'lodash';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
const defaultValue = {
    // cargo_details: 'Fabrics, textiles',
    send_num: 1,
    // import_service_mode: 'CY',
    account_name: '-1',
    // weight: 13000,
    box_type: '40',
    // container_quantity: 1,
    // order_date: dayjs(),
};

export default function HplBookOrderListForm(props) {
    const { id, cache } = props;
    const [allOrderList, setAllOrderList] = useState([]);
    const [account, setAccount] = useState('-1');
    const pollingTimers = useRef({});
    const [expandedMap, setExpandedMap] = useState({});
    const [form] = Form.useForm();
    const [loadingQuotation, setLoadingQuotation] = useState(false);
    const [bookingLoadingMap, setBookingLoadingMap] = useState({});
    const pollingTimerRef = useRef(null);
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    const [orderList, setOrderList] = useState([]);
    const [accountOptions, setAccountOptions] = useState([]);
    const [accountLoading, setAccountLoading] = useState(false);
    // const { data: areaOptions } = useGetAreaQuery();
    const [formDefaultValue, setFormDefaultValue] = useState(null);
    const [selectedRouteMap, setSelectedRouteMap] = useState({});
    const [contractDetailVisible, setContractDetailVisible] = useState(false);
    const [contractDetailData, setContractDetailData] = useState([]);
    const [bookingModalVisible, setBookingModalVisible] = useState(false);
    const [bookingItem, setBookingItem] = useState(null);
    const [bookingAccount, setBookingAccount] = useState('-1');
    const [bookingSubmitting, setBookingSubmitting] = useState(false);
    const [bookingSubmittingMap, setBookingSubmittingMap] = useState({});
    // const handleRouteSelect = (itemId, route) => {
    //     setSelectedRouteMap((prev) => ({
    //         ...prev,
    //         [itemId]: route.id,
    //     }));
    // };
    const bookingAccountOptions = [{ label: '-1', value: '-1' }, ...accountOptions.filter((opt) => opt.value !== '-1')];
    const handleRouteSelect = (itemId, route) => {
        // 不可预订直接忽略点击
        // if (!route.bookable) return;

        setSelectedRouteMap((prev) => {
            const currentSelectedId = prev[itemId];
            if (currentSelectedId === route.id) {
                const newMap = { ...prev };
                delete newMap[itemId];
                return newMap;
            } else {
                return { ...prev, [itemId]: route.id };
            }
        });
    };
    useEffect(() => {
        let finalValue = { ...defaultValue };
        setFormDefaultValue(finalValue);
        appointmentNumberList();
        return () => {
            // 清除所有定时器
            Object.keys(pollingTimers.current).forEach((key) => {
                clearInterval(pollingTimers.current[key]);
            });
            pollingTimers.current = {};
            if (pollingTimerRef.current) {
                clearInterval(pollingTimerRef.current);
            }
        };
    }, [cache]);
    useEffect(() => {
        // 获取账号列表
        setAccountLoading(true);
        axios
            .get('http://183.249.91.105:15600/one/accounts')
            .then((res) => {
                const options = res.data.map((item) => ({ label: item, value: item }));
                setAccountOptions(options);
                setAccountOptions([{ label: '-1', value: '-1' }, ...options]);
            })
            .catch((err) => {
                console.error('获取账号列表失败', err);
                message.error('获取账号列表失败');
            })
            .finally(() => setAccountLoading(false));
    }, []);
    const appointmentNumberList = () => {
        axios
            .get('http://183.249.91.105:15600/one/booking-overview')
            .then((res) => {
                if (res && res.data.items) {
                    setAllOrderList(res.data.items);
                    setOrderList(res.data.items);
                }
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    };
    const orderColumns = [
        { title: 'trace_id', dataIndex: 'trace_id', key: 'trace_id', align: 'center' },
        { title: '起始港', dataIndex: 'originlocation', key: 'originlocation', align: 'center' },
        { title: '目的港', dataIndex: 'destinationlocation', key: 'destinationlocation', align: 'center' },
        { title: 'bookingnumber', dataIndex: 'bookingnumber', key: 'bookingnumber', align: 'center' },
        { title: '开航时间', dataIndex: 'earlytime', key: 'earlytime', align: 'center' },
        { title: '结束时间', dataIndex: 'endtime', key: 'endtime', align: 'center' },
        { title: '价格', dataIndex: 'price', key: 'price', align: 'center' },
        { title: '总价', dataIndex: 'total_price', key: 'total_price', align: 'center' },
        {
            title: '订舱时间',
            dataIndex: 'book_time',
            key: 'book_time',
            align: 'center',
            render: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
    ];

    const contractColumns = [
        {
            title: '账号',
            dataIndex: 'account_name',
            key: 'account_name',
            align: 'center',
            render: (text) => text || '-',
        },
        {
            title: 'booking_number',
            dataIndex: 'booking_number',
            key: 'booking_number',
            align: 'center',
            render: (text) => text || '-',
        },
        {
            title: 'contract_no',
            dataIndex: 'contract_no',
            key: 'contract_no',
            align: 'center',
            render: (text) => text || '-',
        },
        {
            title: 'booking_submitted_at',
            dataIndex: 'booking_submitted_at',
            key: 'booking_submitted_at',
            align: 'center',
            render: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
        {
            title: 'created_at',
            dataIndex: 'created_at',
            key: 'created_at',
            align: 'center',
            render: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
        {
            title: 'trace_id',
            dataIndex: 'trace_id',
            key: 'trace_id',
            align: 'center',
            render: (text) => text || '-',
        },
    ];
    const handleSubmit = () => {
        form.validateFields()
            .then((formValue) => {
                setLoadingQuotation(true);

                // 处理默认账号 '-1'：随机选一个真实账号
                let finalAccount = account;
                if (finalAccount === '-1') {
                    const realOptions = accountOptions.filter((opt) => opt.value !== '-1');
                    if (realOptions.length === 0) {
                        message.error('没有可用的账号');
                        setLoadingQuotation(false);
                        return;
                    }
                    finalAccount = realOptions[Math.floor(Math.random() * realOptions.length)].value;
                }

                const { start_port_en_name, end_port_en_name, box_type, ...rest } = formValue;
                const value = {
                    task_type: 'one_booking_search',
                    ignore_is_run: true,
                    task_info: {
                        start_port_en_name,
                        end_port_en_name,
                        box_type,
                        account_name: finalAccount,
                    },
                    ...rest,
                };

                axios
                    .post('http://183.249.91.105:15600/query/submit', value)
                    .then((response) => {
                        const traceIds = response.data.trace_ids[0];
                        if (traceIds && traceIds.length > 0) {
                            pollTaskStatus(
                                traceIds,
                                () => {
                                    setLoadingQuotation(false);
                                },
                                () => {
                                    setLoadingQuotation(false);
                                },
                            );
                        } else {
                            setLoadingQuotation(false);
                        }
                    })
                    .catch((err) => {
                        message.error('提交失败');
                        setLoadingQuotation(false);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const handleSearch = () => {
        const formValues = form.getFieldsValue();
        const { start_port_en_name, end_port_en_name, box_type } = formValues;

        const hasAccountFilter = !!account && account !== '-1';

        let filtered = allOrderList.filter((item) => {
            // 起始港
            if (start_port_en_name) {
                const startPort = String(item.start_port_name || '').toLowerCase();
                if (!startPort.includes(String(start_port_en_name).toLowerCase())) return false;
            }

            // 目的港
            if (end_port_en_name) {
                const endPort = String(item.end_port_name || '').toLowerCase();
                if (!endPort.includes(String(end_port_en_name).toLowerCase())) return false;
            }

            // 账号
            if (hasAccountFilter) {
                const itemAccount = String(item.account_name || '')
                    .trim()
                    .toLowerCase();
                if (itemAccount !== String(account).trim().toLowerCase()) return false;
            }

            // 箱型（注意：这个 UI 里也是 box_code）
            if (box_type) {
                const box = String(item.box_code || '');
                if (!box.includes(box_type)) return false;
            }

            return true;
        });

        setOrderList(filtered);
    };
    const pollTaskStatus = (traceIds, onSuccess, onError) => {
        const key = 'single';
        if (pollingTimers.current[key]) {
            clearInterval(pollingTimers.current[key]);
            delete pollingTimers.current[key];
        }

        const checkStatus = () => {
            axios
                .get(`http://183.249.91.105:15600/one/booking-options/trace/${traceIds}`)
                .then((res) => {
                    const status = res.data?.status;
                    if (status === 'SUCCESS') {
                        appointmentNumberList();
                        if (onSuccess) onSuccess();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    } else if (status === 'PENDING') {
                        // 继续轮询
                    } else {
                        message.error('操作失败，请稍后重试');
                        if (onError) onError();
                        clearInterval(pollingTimers.current[key]);
                        delete pollingTimers.current[key];
                    }
                })
                .catch((err) => {
                    message.error('查询状态失败');
                    if (onError) onError();
                    clearInterval(pollingTimers.current[key]);
                    delete pollingTimers.current[key];
                });
        };

        checkStatus();
        pollingTimers.current[key] = setInterval(checkStatus, 1000);
    };

    const handleBookingConfirm = () => {
        if (!bookingItem) return;
        const itemKey = bookingItem.id || bookingItem.trace_id;
        const optionId = selectedRouteMap[itemKey];
        if (!optionId) {
            message.warning('请先选择一个航次');
            return;
        }

        // 账号逻辑同查询：默认 -1 → 随机取一个真实账号
        let finalAccount = bookingAccount;
        if (!finalAccount || finalAccount === '-1') {
            const realOptions = accountOptions.filter((opt) => opt.value !== '-1');
            if (realOptions.length === 0) {
                message.error('没有可用的账号');
                return;
            }
            finalAccount = realOptions[Math.floor(Math.random() * realOptions.length)].value;
        }

        setBookingSubmitting(true);
        setBookingSubmittingMap((prev) => ({ ...prev, [itemKey]: true }));

        const value = {
            task_type: 'one_booking_submit',
            task_info: {
                option_id: optionId,
                account_name: finalAccount,
            },
        };

        axios
            .post('http://183.249.91.105:15600/query/submit', value)
            .then((response) => {
                const traceIds = response.data?.trace_ids?.[0];
                if (traceIds && traceIds.length > 0) {
                    setBookingSubmitting(false);
                    setBookingModalVisible(false);
                    pollBookingContractStatus(
                        traceIds,
                        itemKey,
                        () => {
                            message.success('订舱成功');
                            setBookingSubmittingMap((prev) => ({ ...prev, [itemKey]: false }));
                        },
                        () => {
                            setBookingSubmittingMap((prev) => ({ ...prev, [itemKey]: false }));
                        },
                    );
                } else {
                    setBookingSubmitting(false);
                    setBookingSubmittingMap((prev) => ({ ...prev, [itemKey]: false }));
                    message.error('提交失败');
                }
            })
            .catch((err) => {
                console.error(err);
                setBookingSubmitting(false);
                setBookingSubmittingMap((prev) => ({ ...prev, [itemKey]: false }));
                message.error('订舱提交失败');
            });
    };

    const pollBookingContractStatus = (traceId, itemKey, onSuccess, onError) => {
        const key = `contract_${itemKey}`;
        if (pollingTimers.current[key]) {
            clearInterval(pollingTimers.current[key]);
            delete pollingTimers.current[key];
        }

        const stop = () => {
            clearInterval(pollingTimers.current[key]);
            delete pollingTimers.current[key];
        };

        const checkStatus = () => {
            axios
                .get(`http://183.249.91.105:15600/one/contracts/trace/${traceId}`)
                .then((res) => {
                    const status = res.data?.status;
                    if (status === 'SUCCESS') {
                        appointmentNumberList();
                        if (onSuccess) onSuccess();
                        stop();
                    } else if (status === 'PENDING') {
                        // 继续轮询
                    } else {
                        message.error('订舱失败，请稍后重试');
                        if (onError) onError();
                        stop();
                    }
                })
                .catch((err) => {
                    console.error(err);
                    message.error('查询订舱状态失败');
                    if (onError) onError();
                    stop();
                });
        };

        checkStatus();
        pollingTimers.current[key] = setInterval(checkStatus, 1000);
    };
    const handleReset = () => {
        form.resetFields();
        // 重置表单字段，但不要设置账号默认值（账号独立管理）
        form.setFieldsValue({
            start_port_en_name: undefined,
            end_port_en_name: undefined,
            box_type: undefined,
            // container_quantity: undefined,
            // order_date: undefined,
        });
        setAccount(['-1']); // 重置账号标签
        setOrderList(allOrderList); // 恢复全部
    };
    const handleShowContracts = (route) => {
        setContractDetailData(route.contracts || []);
        setContractDetailVisible(true);
    };
    const openBookingModal = (item) => {
        const itemKey = item.id || item.trace_id;
        const selectedOptionId = selectedRouteMap[itemKey];
        if (!selectedOptionId) {
            message.warning('请先选择一个航次');
            return;
        }
        setBookingItem(item);
        setBookingAccount('-1');
        setBookingModalVisible(true);
    };

    const toggleExpand = (id) => {
        setExpandedMap((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    if (!formDefaultValue) return null;

    return (
        <Form form={form} initialValues={formDefaultValue}>
            <Card style={{ minWidth: 1150 }}>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="启始港" name="start_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="目的港" name="end_port_en_name" required rules={[FORM_RULE_REQUIRED]}>
                            <Select options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    {/* <Col span={6}>
                        <Form.Item label="日期" name="order_date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col> */}
                    <Col span={6}>
                        <Form.Item label="账号" style={{ marginBottom: 0 }}>
                            <Select
                                value={account}
                                onChange={setAccount}
                                style={{ width: '100%' }}
                                options={accountOptions}
                                loading={accountLoading}
                                showSearch
                                allowClear
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="箱型" name="box_type">
                            <Select options={createJsonOptions(['20', '40', '45'])} showSearch allowClear></Select>
                        </Form.Item>
                    </Col>
                    {/* <Col span={6}>
                        <Form.Item label="箱量" name="container_quantity">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="日期" name="order_date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="重量（Kg）" name="weight">
                            <InputNumber style={{ width: '100%' }}></InputNumber>
                        </Form.Item>
                    </Col> */}
                </Row>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Space>
                        <Button onClick={handleReset}>重置</Button>
                    </Space>

                    <div style={{ width: '15%', display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={handleSubmit} type="primary" loading={loadingQuotation}>
                            {loadingQuotation ? '正在查询…' : '查询'}
                        </Button>
                        <Button onClick={handleSearch} type="primary">
                            搜索
                        </Button>
                    </div>
                </div>
            </Card>
            <Card style={{ marginTop: 2 }}>
                {orderList.map((item) => (
                    <div
                        key={item.id || item.trace_id}
                        className="order-card"
                        style={{
                            border: '1px solid #aaa7a7',
                            borderRadius: 4,
                            padding: '12px 16px',
                            marginBottom: 8,
                            backgroundColor: '#fafafa',
                            transition: 'border-color 0.2s ease',
                            cursor: 'default',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#40a9ff')}
                        onMouseLeave={(e) => (e.currentTarget.style.borderColor = '#aaa7a7')}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                                style={{
                                    flex: 1,
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    gap: '4px 16px',
                                    paddingBottom: 12,
                                }}
                            >
                                <div>
                                    <strong>Trace ID：</strong>
                                    {item.trace_id || '无'}
                                </div>
                                <div>
                                    <strong>起始港：</strong>
                                    {item.start_port_name || '-'}
                                </div>
                                <div>
                                    <strong>目的港：</strong>
                                    {item.end_port_name || '-'}
                                </div>
                                <div>
                                    <strong>箱型：</strong>
                                    {item.box_code || '-'}
                                </div>

                                <div>
                                    <strong>账号：</strong>
                                    {item.account_name || '-'}
                                </div>
                                <div>
                                    <strong>创建时间：</strong>
                                    {item.created_at ? dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss') : '-'}
                                </div>
                            </div>

                            {/* <Button
                                type="primary"
                                onClick={() => handleBook(item)}
                                loading={bookingLoadingMap[item.id || item.trace_id] || false}
                                style={{ marginLeft: 16, flexShrink: 0 }}
                            >
                                {bookingLoadingMap[item.id || item.trace_id] ? '正在订舱…' : '订舱'}
                            </Button> */}
                            <Button
                                type="primary"
                                onClick={() => openBookingModal(item)}
                                loading={bookingSubmittingMap[item.id || item.trace_id] || false}
                                style={{ marginLeft: 16, flexShrink: 0 }}
                            >
                                {bookingSubmittingMap[item.id || item.trace_id] ? '正在订舱…' : '订舱'}
                            </Button>
                        </div>
                        {item.options.length > 0 && (
                            <div style={{ marginTop: 12, borderTop: '1px solid #e8e8e8', paddingTop: 12 }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                                    {[...item.options]
                                        .sort((a, b) => {
                                            const aHas = a.contracts && a.contracts.length > 0 ? 1 : 0;
                                            const bHas = b.contracts && b.contracts.length > 0 ? 1 : 0;
                                            return bHas - aHas;
                                        })
                                        .map((route) => {
                                            const itemKey = item.id || item.trace_id;
                                            const isSelected = selectedRouteMap[itemKey] === route.id;
                                            const disabled = route.bookable === false;

                                            return (
                                                <div
                                                    key={route.id}
                                                    onClick={() => {
                                                        if (disabled) return;
                                                        handleRouteSelect(itemKey, route);
                                                    }}
                                                    style={{
                                                        position: 'relative',
                                                        width: 220,
                                                        padding: '12px 14px',
                                                        borderRadius: 8,
                                                        border: `1.5px solid ${isSelected ? '#1890ff' : '#aaa5a5'}`,
                                                        backgroundColor: isSelected ? '#e6f4ff' : disabled ? '#f5f5f5' : '#fff',
                                                        opacity: disabled ? 0.55 : 1,
                                                        cursor: disabled ? 'not-allowed' : 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        boxShadow: isSelected
                                                            ? '0 2px 8px rgba(24,144,255,0.25)'
                                                            : '0 1px 3px rgba(0,0,0,0.04)',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 8,
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isSelected && !disabled) {
                                                            e.currentTarget.style.borderColor = '#40a9ff';
                                                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(64,169,255,0.2)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isSelected && !disabled) {
                                                            e.currentTarget.style.borderColor = '#aaa5a5';
                                                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)';
                                                        }
                                                    }}
                                                >
                                                    {' '}
                                                    {route.contracts && route.contracts.length > 0 && (
                                                        <Button
                                                            type="primary"
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleShowContracts(route);
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                top: 12,
                                                                right: 20, // 避开右上角选中三角
                                                                zIndex: 3,
                                                                padding: '0 4px',
                                                                height: 20,
                                                                lineHeight: '20px',
                                                                fontSize: 11,
                                                            }}
                                                        >
                                                            详情
                                                        </Button>
                                                    )}
                                                    {/* 选中角标 */}
                                                    {isSelected && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                right: 0,
                                                                width: 0,
                                                                height: 0,
                                                                borderTop: '22px solid #1890ff',
                                                                borderLeft: '22px solid transparent',
                                                                borderTopRightRadius: 8,
                                                            }}
                                                        ></div>
                                                    )}
                                                    {/* 航次 + 船名 */}
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                        <span
                                                            style={{
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: '#262626',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            {route.voyage_no || '-'}
                                                        </span>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    fontSize: 11,
                                                                    color: '#262626',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                }}
                                                            >
                                                                {route.vessel_name || '-'}
                                                            </span>
                                                            {route.route_type === 'DIRECT' ? (
                                                                <Tag
                                                                    color="green"
                                                                    style={{
                                                                        marginRight: 5,
                                                                        fontSize: 11,
                                                                        lineHeight: '16px',
                                                                        padding: '0 4px',
                                                                    }}
                                                                >
                                                                    直达
                                                                </Tag>
                                                            ) : route.route_type === 'TRANSIT' ? (
                                                                <Tag
                                                                    color="gold"
                                                                    style={{
                                                                        marginRight: 5,
                                                                        fontSize: 11,
                                                                        lineHeight: '16px',
                                                                        padding: '0 4px',
                                                                    }}
                                                                >
                                                                    中转
                                                                </Tag>
                                                            ) : (
                                                                <span style={{ fontSize: 11 }}>-</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* 分隔线 */}
                                                    <div style={{ height: 1, backgroundColor: '#f0f0f0' }} />
                                                    {/* 价格区 */}
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                                                            <span style={{ color: '#262626' }}>ocean_freight_amount</span>
                                                            <span style={{ color: '#595959' }}>{route.ocean_freight_amount ?? '-'}</span>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                                                            <span style={{ color: '#262626' }}>折扣</span>
                                                            <span style={{ color: '#52c41a' }}>{route.promotion_amount ?? '-'}</span>
                                                        </div>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                marginTop: 2,
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 12, color: '#262626' }}>总价</span>
                                                            <span style={{ fontSize: 16, fontWeight: 700, color: '#fa541c' }}>
                                                                {route.total_amount ?? '-'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {/* 分隔线 */}
                                                    <div style={{ height: 1, backgroundColor: '#f0f0f0' }} />
                                                    {/* 日期 + Route ID */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 3,
                                                            fontSize: 11,
                                                            color: '#595959',
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <span style={{ color: '#262626' }}>departure_date</span>
                                                            <span>{route.departure_date || '-'}</span>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <span style={{ color: '#262626' }}>arrival_date</span>
                                                            <span>{route.arrival_date || '-'}</span>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <span style={{ color: '#262626' }}>航程</span>
                                                            <span>{route.transit_days || '-'}</span>
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <span style={{ color: '#262626' }}>ID</span>
                                                            <span style={{ fontFamily: 'monospace' }}>{route.id}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}
                        {item.orders && item.orders.length > 0 && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginTop: 12,
                                    borderTop: '1px solid #9b9898',
                                }}
                            >
                                <Button
                                    type="link"
                                    onClick={() => toggleExpand(item.id)}
                                    icon={
                                        expandedMap[item.id] ? (
                                            <UpOutlined style={{ fontSize: 15 }} />
                                        ) : (
                                            <DownOutlined style={{ fontSize: 15 }} />
                                        )
                                    }
                                    style={{ padding: '0 14px', color: '#8b8484' }}
                                />
                                {expandedMap[item.id] && (
                                    <Table
                                        columns={orderColumns}
                                        dataSource={item.orders}
                                        rowKey={(record) => record.id || record.trace_id || Math.random().toString()}
                                        size="small"
                                        bordered
                                        pagination={false}
                                        style={{ marginTop: 8, width: '100%' }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </Card>
            <Modal
                title="订单详情"
                open={contractDetailVisible}
                onCancel={() => setContractDetailVisible(false)}
                footer={null}
                width={1000}
                destroyOnClose
            >
                <Table
                    columns={contractColumns}
                    dataSource={contractDetailData}
                    rowKey={(record) => record.id || record.trace_id || Math.random().toString()}
                    size="small"
                    bordered
                    pagination={false}
                    scroll={{ x: 950 }}
                />
            </Modal>
            <Modal
                title="选择订舱账号"
                open={bookingModalVisible}
                onOk={handleBookingConfirm}
                onCancel={() => setBookingModalVisible(false)}
                confirmLoading={bookingSubmitting}
                destroyOnClose
            >
                <Select
                    value={bookingAccount}
                    onChange={setBookingAccount}
                    style={{ width: '100%' }}
                    options={bookingAccountOptions}
                    loading={accountLoading}
                    showSearch
                    allowClear
                />
            </Modal>
        </Form>
    );
}
